import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceEventView } from 'src/app/data/model/device-event-view';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { DeviceEventViewApiService } from '../../../shared/api/services/events-api.service';
import {Icon, DomEvent, LeafletEvent, Map, LayerGroup, MapOptions, tileLayer, LatLng, latLng, Marker , MarkerClusterGroup, MarkerClusterGroupOptions, divIcon, ZoomAnimEvent, FullscreenOptions, Control, DomUtil, control, marker } from 'leaflet';
import { FormBuilder } from '@angular/forms';
import { getCombinedModifierFlags } from 'typescript';
import { timestamp } from 'rxjs';
import { DatePipe, DATE_PIPE_DEFAULT_TIMEZONE, registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import * as moment from 'moment';
import { mapURL } from 'src/environments/environment.api';


@Component({
    standalone: false,
    selector: 'app-dialog-map',
    templateUrl: './dialog-map.component.html',
    styleUrls: ['./dialog-map.component.scss'],
})
export class DialogMapComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any
      ) { }

    @Output() map$: EventEmitter<Map>= new EventEmitter;
    @Output() zoom$: EventEmitter<number>=new EventEmitter;
    zoom!:number;
    public map!: Map;

    marker_icon =  Icon.extend({
      options:
        {
          iconSize: [21, 31], // size of the icon
          iconAnchor: [10, 24], // 8, 24 point of the icon which will correspond to marker's location
          popupAnchor: [0, -51],  
          iconUrl: '../../../../assets/images/marker-icon.png'
        }
    })

    getCoords():LatLng {
      if(this.data.coords !== null){
        var coord = this.data.coords.split(" ");
        const mark1= coord[1].split("(");
        const mark2= coord[2].split(")");
        const x=mark2[0] as unknown
        const y= mark1[1] as unknown
        var coords = new LatLng(x as number, y as number)
        return coords
        }
      return new LatLng(45.800084381319905, 13.38134765625)
    }

    mapUrl = mapURL.mapUrl !== '${mapURL}' ? mapURL.mapUrl : mapURL.defaultMapUrl;
    @Input() options: MapOptions= {
      layers:[tileLayer(`${this.mapUrl}/styles/m2openmaptiles/{z}/{x}/{y}.png`, {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      })],
      zoom:17,
      center:latLng(this.getCoords()),
    };

    onMapReady(map: Map) {
        this.map = map;
        this.map$.emit(map);
        this.zoom = map.getZoom();
        this.zoom$.emit(this.zoom);
        var popup_data:string
        if (this.data.metadata ? this.data.metadata:'' != ''){
          if (this.data.metadata.well_known.FuelLevel1 == 102){
            this.data.metadata.well_known.FuelLevel1=0;
          }
          popup_data="<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Veicolo: "+this.data.licenseplate+"</td></tr><tr><td><b/>Kilometri: "+this.data.metadata.well_known.Odo+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Carburante: "+this.data.metadata.well_known.Fuel+"</td></tr><tr><td><b/>Data:"+moment(this.data.metadata.well_known.Updts).format('DD/MM/yyyy, HH:mm:ss')+"</td></tr><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Livello Carburante 0: "+this.data.metadata.well_known.FuelLevel0.toFixed(2)+"%</td></tr><tr><td><b/>Livello Carburante 1: "+this.data.metadata.well_known.FuelLevel1.toFixed(2)+"%</td></tr></table></div>";
        }
        else {
          popup_data="<div><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Veicolo: "+this.data.licenseplate+"</td></tr><tr><td><b/>Anomalia: "+this.data.description+"</td></tr></table><table style=\"width:100%; border-radius: 0px; font-size:15px;\"><tr style=\"background-color:#3f51b5; color:white\"><td><b/>Note: "+this.data.notes+"</td></tr><tr><td><b/>Data:"+moment(this.data.created_at).format('DD/MM/yyyy, HH:mm:ss')+"</td></tr></table></div>";
        }
        marker(this.getCoords(), {icon:new this.marker_icon}).bindPopup(popup_data, {closeButton: false}).addTo(map);
      }

    onMapZoomEnd(e: LeafletEvent) {
      this.zoom = e.target.getZoom();
      this.zoom$.emit(this.zoom);
    }
}

export type DialogMapParams = {
  data: any;
};
